/// <reference path="../../../../WebUI/typings/tsd.d.ts" />

import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Rest from "../../Generated/RestClient";
import {TooltipControl, Borders} from "../../../../Intercom.ReactUI/Views/index";
import {BotEditor} from "./BotEditor";
import { BlockRowInputField } from '../../Views/Shared/BlockRowInputField';
import { BlockRowInputTooltipDisposer, BlockRowInputLabel } from '../../Views/Shared/BlockRowInputLabel';

export interface BotEditorRowProps extends React.Props<BotEditorRow> {
    label: string;

    required?: boolean,
    inputPlaceholder?: string;
    inputId?: string;
    inputMaxlen?: number;
    inputMinlen?: number;
    inputIsArray?: boolean;
    inputReadonly?: boolean;
    editor?: BotEditor;
    password?: boolean;

    inputTip?: string;
    tipAsHtml?: boolean;
    onTooltipVisibilityChanged?: (visible: boolean, disposer: BlockRowInputTooltipDisposer) => void;
}

export interface BotEditorRowState {
}

export class BotEditorRow extends React.Component<BotEditorRowProps, BotEditorRowState> {
    private onPropertyChanged = (ev: React.FormEvent<any>) => {
        if (this.props.inputIsArray && this.props.editor) {
            this.props.editor.handleArrayChange(this.props.inputId, ev);
            return;
        }

        if (this.props.editor) {
            this.props.editor.handleChange(this.props.inputId, ev);
        }
    }

    private convertIfArray(value: any): string {
        if (value && this.props.inputIsArray) {
            return (value as Array<any>).join(',');
        }

        return value;
    }
    public render() {
        if (!this.props.editor) {
            return null;
        }

        return (
            <BlockRowInputField
                id={this.props.inputId}
                containerClassName="detail-row"
                errorContainerClassName="input-in-error"
                label={this.props.label}
                required={this.props.required}
                placeholder={this.props.inputPlaceholder}
                maxlen={this.props.inputMaxlen}
                readonly={this.props.inputReadonly}
                password={this.props.password}
                error={this.props.editor.state.errors[this.props.inputId]}
                value={this.convertIfArray(this.props.editor.state.bot[this.props.inputId])}
                tip={this.props.inputTip}
                tipAsHtml={this.props.tipAsHtml}
                onTooltipVisibilityChanged={this.props.onTooltipVisibilityChanged}
                onValueChanged={this.onPropertyChanged}/>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/BotEditorRow.tsx